import { render } from "./LangBtn.vue?vue&type=template&id=7eb61a32&scoped=true"
import script from "./LangBtn.vue?vue&type=script&lang=ts"
export * from "./LangBtn.vue?vue&type=script&lang=ts"

import "./LangBtn.vue?vue&type=style&index=0&id=7eb61a32&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7eb61a32"

export default script